import { render, staticRenderFns } from "./CefrScoreEditorSlider.vue?vue&type=template&id=665e3ddb&scoped=true&"
import script from "./CefrScoreEditorSlider.vue?vue&type=script&lang=js&"
export * from "./CefrScoreEditorSlider.vue?vue&type=script&lang=js&"
import style0 from "./CefrScoreEditorSlider.vue?vue&type=style&index=0&id=665e3ddb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e3ddb",
  null
  
)

export default component.exports